import { render, staticRenderFns } from "./WarningIcon.vue?vue&type=template&id=ca35f0f8&"
import script from "./WarningIcon.vue?vue&type=script&lang=js&"
export * from "./WarningIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports